import { render } from "./ConfigurationsTab.vue?vue&type=template&id=5f4def49&scoped=true"
import script from "./ConfigurationsTab.vue?vue&type=script&lang=js"
export * from "./ConfigurationsTab.vue?vue&type=script&lang=js"

import "./ConfigurationsTab.vue?vue&type=style&index=0&id=5f4def49&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4def49"]])

export default __exports__